export const Data = [
 { 
id: 0,
price: "$438",
pricebackground:"bg-dark plan-circle",
planType:"Basic",
buttonText:"Buy Now",
 packaged: ["Data source", "Responsive Design", "Personal Licence", "3x Revisions",  "Extimated time in 30 days", "Max 10 pages"],
buttonType:"btn btn-outline-dark d-block mx-auto",
},
 { 
id: 1,
price: "$621",
pricebackground:"bg-info plan-circle",
planType:"Standard",
buttonText:"Buy Now",
 packaged: ["Data source", "Responsive Design", "Personal Licence", "3x Revisions",  "Extimated time in 30 days", "Max 10 pages"],
buttonType:"btn btn-info d-block mx-auto",
},
 { 
id: 2,
price: "$914",
pricebackground:"bg-primary plan-circle",
planType:"Business",
 packaged: ["Data source", "Responsive Design", "Personal Licence", "3x Revisions",  "Extimated time in 30 days", "Max 10 pages"],
buttonText:"Buy Now",
buttonType:"btn btn-outline-primary d-block mx-auto",
},
] ;
export const benefits = [
 {
 packaging: ["Data source", "Responsive Design", "Personal Licence", "3x Revisions",  "Extimated time in 30 days", "Max 10 pages"]

},
 {
 packaging: ["Data source", "Responsive Design", "Personal Licence", "5x Revisions",  "Extimated time in 23 days", "Max 20 pages"]

},
 {
 packaging: ["Data source", "Responsive Design", "Personal Licence", "10x Revisions",  "Extimated time in 15 days", "Max 35 pages"]
}
];

export const people = [
 {
  id: 1,
  image:
   'https://res.cloudinary.com/diqqf3eq2/image/upload/v1595959131/person-2_ipcjws.jpg',
  name: 'maria ferguson',
  title: 'Office manager',
  quote:
   'Fingerstache umami squid, kinfolk subway tile selvage tumblr man braid viral kombucha gentrify fanny pack raclette pok pok mustache.',
 },
 {
  id: 2,
  image:
   'https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883417/person-3_ipa0mj.jpg',
  name: 'john doe',
  title: 'Computer guy',
  quote:
   'Gastropub sustainable tousled prism occupy. Viral XOXO roof party brunch actually, chambray listicle microdosing put a bird on it paleo subway tile squid umami.',
 },
 {
  id: 3,
  image:
   'https://res.cloudinary.com/diqqf3eq2/image/upload/v1595959121/person-1_aufeoq.jpg',
  name: 'peter smith',
  title: 'Product designer',
  quote:
   'Drinking vinegar polaroid street art echo park, actually semiotics next level butcher master cleanse hammock flexitarian ethical paleo.',
 },
 {
  id: 4,
  image:
   'https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883334/person-1_rfzshl.jpg',
  name: 'susan andersen',
  title: 'The boss',
  quote:
   'Marfa af yr 3 wolf moon kogi, readymade distillery asymmetrical seitan kale chips fingerstache cloud bread mustache twee messenger bag. ',
 },
];


